import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Axia CEP service
 */
@Injectable()
export class CepService {

    constructor(
        private readonly http: HttpClient
    )
    { }

    public findCep(zipcode): Observable<any> {
        return this.http.get(`https://viacep.com.br/ws/${zipcode}/json`, {})
            .pipe(
                map((data: any) => {
                    return data;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }
}